jQuery(function () {
  function boot() {
    jQuery("#navToggle").on("click", function () {
      jQuery("#navMenu").toggleClass("is-open");
      jQuery(this).toggleClass("is-active");
      jQuery(this).attr("aria-expanded", jQuery("#navMenu").hasClass("is-open"));
    });

    jQuery(".nav-menu a").on("click", function () {
      jQuery("#navMenu").removeClass("is-open");
      jQuery("#navToggle").removeClass("is-active").attr("aria-expanded", false);
    });

    jQuery(".faq-item__pergunta").on("click", function () {
      var $item = jQuery(this).closest(".faq-item");
      var $resposta = $item.find(".faq-item__resposta");
      var isOpen = $item.hasClass("is-open");

      jQuery('.faq-item').removeClass('is-open').find('.faq-item__resposta').css('max-height', 0);
      jQuery('.faq-item__pergunta').attr('aria-expanded', false);

      if (!isOpen) {
        $item.addClass("is-open");
        $resposta.css(
          "max-height",
          $resposta.find(".faq-item__resposta-inner")[0].scrollHeight + "px",
        );
        jQuery(this).attr("aria-expanded", true);
      }
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
});
